import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class GoldPriceService {

  constructor(private _HttpClient:HttpClient) { }
  GetGoldPrice():Observable<any>{
      return this._HttpClient.get(`${environment.Server_URL}/GoldPrice/Get`);
    }
    AddOrUpdateGoldPrice(Data:any):Observable<any>{
      return this._HttpClient.post(`${environment.Server_URL}/GoldPrice/AddOrUpdate`,Data);
    }
}
